import { Outlet } from "react-router";
import { Toaster } from "@/components/ui/sonner";
import { ScrollRestoration } from "react-router";

const AppLayout = () => {
  return (
    <>
      {/* <Navbar /> */}
      <ScrollRestoration />
      <Outlet />
      <Toaster />
    </>
  );
};

export default AppLayout;
